"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialShareBase = void 0;

var react_1 = __importStar(require("react"));

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var WrapperClean = function WrapperClean(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return react_1.default.createElement(fclasses_1.Div, __assign({}, props), children);
};
/**
 * Display a social share button.
 *
 * @param buttonContent - a string or JSX element provides content of share button.
 *        for example, to display a Material Share icon, use
 *            <MaterialIcon className="bl-material-icons" icon="share" />
 */


var ButtonClean = function ButtonClean(_a) {
  var content = _a.buttonContent,
      onClick = _a.onClick,
      props = __rest(_a, ["buttonContent", "onClick"]);

  return react_1.default.createElement(fclasses_1.Button, __assign({
    onClick: onClick
  }, props), content || 'Share');
};

var providersComponents = {
  ProvidersWrapper: fclasses_1.Ul,
  ProviderList: fclasses_1.Li
};

var ProvidersClean = function ProvidersClean(_a) {
  var components = _a.components,
      expanded = _a.expanded,
      providers = _a.providers;
  var ProvidersWrapper = components.ProvidersWrapper,
      ProviderList = components.ProviderList;
  var ProvidersWrapperStyled = lodash_1.flow(fclasses_1.addClassesIf(function () {
    return !expanded;
  })('hidden'), fclasses_1.addClassesIf(function () {
    return expanded;
  })('flex'))(ProvidersWrapper);
  return react_1.default.createElement(ProvidersWrapperStyled, null, providers.map(function (Provider) {
    return react_1.default.createElement(ProviderList, {
      key: Provider.id
    }, Provider.element);
  }));
};

var SocialShareProviders = fclasses_1.designable(providersComponents, 'SocialShareProviders')(ProvidersClean);
var socialShareComponents = {
  SocialShareWrapper: WrapperClean,
  SocialShareButton: ButtonClean,
  SocialShareProdviders: SocialShareProviders
};

exports.SocialShareBase = function (_a) {
  var components = _a.components,
      buttonContent = _a.buttonContent,
      providers = _a.providers,
      props = __rest(_a, ["components", "buttonContent", "providers"]);

  var _b = react_1.useState(false),
      expanded = _b[0],
      setExpanded = _b[1];

  var toggleExpanded = function toggleExpanded() {
    return setExpanded(!expanded);
  };

  var SocialShareWrapper = components.SocialShareWrapper,
      SocialShareButton = components.SocialShareButton,
      SocialShareProdviders = components.SocialShareProdviders;
  return react_1.default.createElement(SocialShareWrapper, __assign({}, props), react_1.default.createElement(SocialShareButton, {
    buttonContent: buttonContent,
    onClick: toggleExpanded
  }), react_1.default.createElement(SocialShareProdviders, {
    expanded: expanded,
    providers: providers
  }));
};

var SocialShare = fclasses_1.designable(socialShareComponents, 'SocialShare')(exports.SocialShareBase);
exports.default = SocialShare;